export const insightsAreaData = [
  {
    name: "Jan",
    uv: 2513, // Totale claimkosten
  },
  {
    name: "Feb",
    uv: 2649,
  },
  {
    name: "Mar",
    uv: 2249,
  },
  {
    name: "Apr",
    uv: 3498,
  },
  {
    name: "Mei",
    uv: 3564,
  },
  {
    name: "Jun",
    uv: 2249,
  },
  {
    name: "Jul",
    uv: 2789,
  },
  {
    name: "Aug",
    uv: 2634,
  },
  {
    name: "Sep",
    uv: 2134,
  },
  {
    name: "Okt",
    uv: 0,
  },
  {
    name: "Nov",
    uv: 0,
  },
  {
    name: "Dec",
    uv: 0,
  },
];
